import {combineReducers} from 'redux';
import auth from './modules/auth/reducer';
import modals from './modules/modals/reducer';

export default combineReducers({
    auth,
    modals
});
